import { useEffect, useState } from "react";
import Moment from "react-moment";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { getAlarms, readAlarm, readAlarmMessage } from "redux/actions/setAlarmActions";
import { classNames } from "helpers/classNames";
import { BackButton } from "components/BackButton";
import { Layout } from "components/Layout";
import {Disclaimer} from "../components/Disclaimer";
import messageReadIcon from "../static/img/ic-alarm-massage-read.svg";
import messageUnreadIcon from "../static/img/ic-alarm-massage-unread.svg";
import close from "../static/img/ic-close.svg";

/**
 * @api {get} /alarms запросы о помощи
 * @apiGroup profile
 * @apiName запросы о помощи
 *
 * @apiDescription <p>Страница просмотра списка запросов о помощи</p>
 * <p>Компонент <code>AlarmsPage.js</code> <a href="../client/src/pages/AlarmsPage.js">ссылка на файл</a></p>
 */

export const AlarmsPage = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t, i18n } = useTranslation();
    const { alarms } = useSelector((state) => state.alarm);
    const [selectedMessage, setSelectedMessage] = useState(null);

    useEffect(() => {
        dispatch(getAlarms());
    }, [dispatch]);

    const clickAlarmHandler = (alarm) => {
        dispatch(readAlarm(alarm._id));
        history.push(`/pupils/${alarm.pupil._id}?from=alarms`);
    };

    const handleMessageClick = (e, alarm) => {
        e.stopPropagation();
        setSelectedMessage(alarm);
        if (!alarm.messageReadAt) {
            dispatch(readAlarmMessage(alarm._id));
        }
    };

    const closeMessageModal = () => {
        setSelectedMessage(null);
    };

    const formatDateTime = (date) => {
        if (!date) return "";
        return new Date(date).toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <Layout>
            <div className="page">
                <header className="page__header">
                    <BackButton
                    link={"/dashboard"}/>
                    <p className="page__title">{t("alarms_title")}</p>
                </header>
                <div className="page__content">
                    <Disclaimer text={t("alarm_disclaimer")}/>
                    <div className="list">
                        {alarms.map((alarm) => (
                            <button
                                key={alarm._id}
                                onClick={() => clickAlarmHandler(alarm)}
                                className={classNames("list__item list__item-button", {
                                    list__item_red: !alarm.readAt,
                                })}
                                style={{ position: 'relative' }}
                            >
                                <p>
                                    {alarm.pupil.name} {alarm.pupil.surname}
                                </p>
                                <p className="list__desc">
                                    <Moment locale={i18n.language} format="HH:mm, DD MMM, YYYY">
                                        {alarm.createdAt}
                                    </Moment>
                                </p>
                                {alarm.message && (
                                    <div
                                        onClick={(e) => handleMessageClick(e, alarm)}
                                        title={alarm.messageReadAt ? `Прочитано ${formatDateTime(alarm.messageReadAt)}` : "Непрочитанное сообщение"}
                                        style={{
                                            position: 'absolute',
                                            right: '15px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            width: '32px',
                                            height: '32px',
                                            backgroundColor: 'white',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            zIndex: 10
                                        }}
                                    >
                                        <img
                                            src={alarm.messageReadAt ? messageReadIcon : messageUnreadIcon}
                                            alt="message"
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                display: 'block'
                                            }}
                                        />
                                    </div>
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            
            {selectedMessage && (
                <div className="sureAlert" onClick={closeMessageModal}>
                    <div className="sureAlert__inner" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px', padding: '20px' }}>
                        <h3 style={{ marginBottom: '20px' }}>Сообщение от ученика</h3>
                        <div style={{ textAlign: 'left', padding: '0 20px', marginBottom: '20px' }}>
                            <p style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
                                <strong>{selectedMessage.pupil.name} {selectedMessage.pupil.surname}</strong>
                            </p>
                            <p style={{ fontSize: '14px', color: '#999', marginBottom: '15px' }}>
                                <Moment locale={i18n.language} format="HH:mm, DD MMMM YYYY">
                                    {selectedMessage.createdAt}
                                </Moment>
                            </p>
                            <div style={{
                                padding: '15px',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '8px',
                                fontSize: '15px',
                                lineHeight: '1.5',
                                color: '#122443',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word'
                            }}>
                                {selectedMessage.message}
                            </div>
                        </div>
                        <button onClick={closeMessageModal} className="send" style={{ marginBottom: '20px' }}>
                            Закрыть
                        </button>
                        <button onClick={closeMessageModal} className="close">
                            <img alt="" src={close} />
                        </button>
                    </div>
                </div>
            )}
        </Layout>
    );
};
